<template>
  <el-dialog
    width="360px"
    title="Редактирование атрибутов объекта"
    :visible="visible"
    @close="cancel"
    class="map-editor-create-modal"
  >
    <div class="map-editor-create-modal__container">
      <div class="map-editor-create-modal__nodata" v-if="!attributes.length">
        У данного источника данных отсутствуют атрибуты для заполнения
      </div>
      <ul class="map-editor-create-modal__attributes" v-else>
        <li
          class="map-editor-create-modal__item"
          v-for="item in attributes"
          :key="item.name"
        >
          <div class="map-editor-create-modal__title">
            {{ item.name }}
          </div>
          <div class="map-editor-create-modal__value">
            <el-input
              class="r-input"
              size="mini"
              v-model="item.value"
              v-if="item.type === 'string'"
            />
            <el-input-number
              class="r-input-number"
              :controls="false"
              size="mini"
              type="number"
              v-model="item.value"
              v-else
            />
          </div>
        </li>
      </ul>
    </div>
    <div slot="footer" class="gcp-settings__actions">
      <el-button class="r-button" type="info" size="mini" @click="cancel">
        Отменить
      </el-button>
      <el-button
        class="r-button main"
        type="primary"
        size="mini"
        @click="saveObject"
      >
        Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["editor-state", "editor-controller", "draw", "visible"],
  data() {
    return {
      attributes: []
    };
  },
  methods: {
    modifyType(geom_type) {
      switch (geom_type) {
        case "multi_polygon":
          return "polygon";
        case "multi_line_string":
          return "line_string";
        case "multi_point":
          return "point";
        default:
          return geom_type;
      }
    },
    cancel() {
      const { creatingObject, geom_type } = this.editorState;
      if (creatingObject) this.draw.delete(creatingObject.id);
      // if (geom_type === "zones") this.editorController.loadLayerData();
      this.draw.changeMode(`draw_${this.modifyType(geom_type)}`);
      this.$emit("toggle-create-modal");
    },
    saveObject() {
      const { creatingObject, creatingCallback } = this.editorState;

      if (creatingCallback) {
        this.attributes.forEach(({ name, value }) => {
          creatingObject.setProperty(name, value);
        });
        creatingCallback();
      }
      this.$emit("toggle-create-modal");
    }
  },
  created() {
    const { objectFields } = this.editorState;

    this.attributes = objectFields.map(({ type, name }) => ({
      type,
      name,
      value: null
    }));
  }
};
</script>

<style lang="scss">
.map-editor-create-modal {
  &__nodata {
    color: var(--text_secondary) !important;
    font-size: 14px;
    text-align: center;
    padding: 20px;
  }

  &__attributes {
    max-height: 50vh;
    overflow: auto;
    padding: 0 10px;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
    margin-right: 20px;
    color: var(--text_secondary) !important;
  }

  &__value {
    width: 50%;

    .r-input-number {
      width: 100% !important;

      .el-input__inner {
        // padding: 0 15px !important;
        text-align: left !important;
      }
    }
  }
}
</style>
